import { render, staticRenderFns } from "./subsidaries-detail-table-panel.vue?vue&type=template&id=63f03a76&scoped=true&lang=pug"
import script from "./subsidaries-detail-table-panel.vue?vue&type=script&lang=js"
export * from "./subsidaries-detail-table-panel.vue?vue&type=script&lang=js"
import style0 from "./subsidaries-detail-table-panel.vue?vue&type=style&index=0&id=63f03a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f03a76",
  null
  
)

export default component.exports